module.exports = __webpack_public_path__ + "media/images/top/qa/ranking_banner04-78ea50b373c0266986777c0972d9a150.png";